import React, { useState } from "react";

import { Dropdown, Form, Icon, Popup } from "semantic-ui-react";

import moment, { Moment } from "moment";

import LoadingIcon from "../HCU/LoadingIcon";

import { parseDateTimeENAndTH } from "./sequence/SetupWorkSchedule";

type SelectMonthYearProps = {
  isLoading?: boolean;
  viewMonth: Moment;
  setViewMonth: (value: moment.Moment) => void;
};

const SelectMonthYear = (props: SelectMonthYearProps) => {
  const [showMonthSetup, setShowMonthSetup] = useState(false);

  const listYears = Array.from(
    { length: 20 },
    (unused, index) => Number(props.viewMonth.format("YYYY")) - 10 + index + 1
  );

  const yearsOptions = listYears.map((year) => ({
    key: year,
    text: `${year} (พ.ศ. ${year + 543})`,
    value: year,
  }));

  const monthsOptions = moment
    .months()
    .map((month, index) => ({ key: month, text: month, value: index }));

  return (
    <div>
      <Popup
        open={showMonthSetup}
        position="top right"
        on="click"
        onClose={() => {
          setShowMonthSetup(false);
        }}
        onOpen={() => {
          setShowMonthSetup(true);
        }}
        content={
          <Form size="tiny">
            <div style={{ margin: "-0.25rem 0 0.35rem" }}>Select Month & Year</div>
            <div style={{ alignItems: "baseline", display: "flex", gap: "10px" }}>
              <Icon
                id="SelectMonthYear-Icon-Previous"
                style={{ marginRight: "-5px" }}
                name="chevron left"
                link
                onClick={() => {
                  props.setViewMonth(props.viewMonth.clone().add(-1, "months"));
                }}
              />
              <Dropdown
                id="SelectMonthYear-Dropdown-Month"
                value={props.viewMonth.month()}
                selection
                options={monthsOptions}
                onChange={(e, { value }) => {
                  props.setViewMonth(props.viewMonth.clone().month(value as number));
                  setShowMonthSetup(false);
                }}
              />
              <Dropdown
                id="SelectMonthYear-Dropdown-Year"
                value={props.viewMonth.year()}
                selection
                options={yearsOptions}
                onChange={(e, { value }) => {
                  props.setViewMonth(props.viewMonth.clone().year(value as number));
                  setShowMonthSetup(false);
                }}
              />
              <Icon
                id="SelectMonthYear-Icon-Next"
                style={{ marginLeft: "-5px" }}
                name="chevron right"
                link
                onClick={() => {
                  props.setViewMonth(props.viewMonth.clone().add(1, "months"));
                }}
              />
            </div>
          </Form>
        }
        trigger={
          <div
            id="SelectMonthYear-Div-PreviewMonthYear"
            style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              marginRight: "1rem",
              position: "relative",
            }}
          >
            <LoadingIcon color="grey" loading={props.isLoading} name="calendar alternate outline" />
            <label>{parseDateTimeENAndTH(props.viewMonth)}</label>
          </div>
        }
      />
    </div>
  );
};

SelectMonthYear.displayName = "SelectMonthYear";

export default React.memo(SelectMonthYear);
